import React, { Component } from 'react';

type AudioVisualizerProps = {
    audioData: Uint8Array;
};
type AudioVisualizerState = {
    audioData: any;
};
class AudioVisualiser extends React.Component<AudioVisualizerProps, AudioVisualizerState> {
    canvas: React.RefObject<HTMLCanvasElement>;

    wave: number[];

    timer: number;

    constructor(props: any) {
        super(props);
        this.canvas = React.createRef();
        this.wave = [];
        this.timer = 0;
    }

    componentDidUpdate() {
        this.draw();
    }

    draw() {
        this.timer++;
        if (this.timer > 1) {
            this.timer = 0;
            const { audioData } = this.props;
            this.wave = [audioData[0], ...this.wave].slice(0, 12)
        }
        //this.setState({ wave: newWave.slice(0, 20) })
        // const canvas = this.canvas?.current;
        // if (canvas) {
        //     const height = canvas.height;
        //     const width = canvas.width;
        //     const context = canvas.getContext('2d');
        //     let x = 0;
        //     const sliceWidth = (width * 1.0) / audioData.length;
        //     if (context) {
        //         context.lineWidth = 6;
        //         context.strokeStyle = '#541AB9';
        //         context.clearRect(0, 0, width, height);

        //         context.beginPath();
        //         context.moveTo(0, height / 2);
        //         for (const item of audioData) {
        //             const y = (item / 255.0) * height;
        //             context.lineTo(x, y);
        //             x += sliceWidth;
        //         }
        //         context.lineTo(x, height / 2);
        //         context.stroke();
        //     }
        // }
    }

    render() {
        //return this.wave.toString()
        return <div className='flex flex-row gap-[2px] w-[72px] h-[36px] bg-primary-200 rounded-lg items-center p-2'>
            {
                this.wave.map((val, index) => {
                    let he = (val-125);
                    he = he === 0 ? 2 : he > 32 ? 32 : he;
                    return (
                        <div className='w-[4px] bg-primary rounded-lg' key={index} style={{ height: `${he}px` }}>

                        </div>)
                })
            }
        </div>

        //return <BarVisualizer audioData={this.props.audioData.slice(0, 20)}
        //return <canvas className='w-[120px] h-[32px] rounded-lg bg-primary-200' ref={this.canvas} />;
    }
}

export default AudioVisualiser;